// v0.9.5 Twitch chat integration — anonymous mode via tmi.js.
// The streamer types their channel name in Streamer Mode; we connect anonymously
// and listen for !1 !2 !3 vote messages that map to card reward picks.

import tmi from 'tmi.js';

let currentClient = null;
let currentChannel = null;
let voteCallback = null;

export async function connectAnonymousChat(channel, onVote) {
  await disconnectChat();
  const cleanChannel = (channel || '').trim().toLowerCase().replace(/^#/, '');
  if (!cleanChannel) return { ok: false, error: 'No channel name' };
  currentChannel = cleanChannel;
  voteCallback = onVote;
  try {
    const client = new tmi.Client({
      channels: [cleanChannel],
      options: { debug: false },
      connection: { reconnect: true, secure: true },
    });
    currentClient = client;
    client.on('message', (chan, tags, message, self) => {
      if (self) return;
      const trimmed = String(message).trim().toLowerCase();
      // Accept !1 / !2 / !3 / 1 / 2 / 3 (letting chat lazily type numbers)
      const m = trimmed.match(/^!?([1-9])$/);
      if (m && voteCallback) {
        const choice = parseInt(m[1], 10) - 1;
        const voter = tags['display-name'] || tags['username'] || 'anon';
        voteCallback(choice, voter);
      }
    });
    await client.connect();
    return { ok: true, channel: cleanChannel };
  } catch (e) {
    currentClient = null;
    return { ok: false, error: String(e) };
  }
}

export async function disconnectChat() {
  if (currentClient) {
    try { await currentClient.disconnect(); } catch (e) { /* noop */ }
  }
  currentClient = null;
  currentChannel = null;
  voteCallback = null;
}

export function chatStatus() {
  return { connected: !!currentClient, channel: currentChannel };
}
